"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarEditTooltip = void 0;
const react_1 = __importDefault(require("react"));
const svgIcons_1 = require("../../../../../svgIcons");
require("./avatarUploadTooltip.scss");
const AvatarEditTooltip = (props) => {
    return (react_1.default.createElement("div", { className: 'buttons-wrapper' },
        react_1.default.createElement("label", { className: 'mb-0', "data-qa": 'img-upload-label-3', htmlFor: "avatar-upload" },
            react_1.default.createElement("div", { className: 'btn btn-add' },
                react_1.default.createElement(svgIcons_1.AttachIcon, null),
                "Upload Photo")),
        react_1.default.createElement("div", { onClick: () => props.removeAvatar(), className: 'btn btn-remove mt-2' },
            react_1.default.createElement(svgIcons_1.DeleteIcon, { className: 'delete-icon' }),
            "Delete Photo")));
};
exports.AvatarEditTooltip = AvatarEditTooltip;
exports.default = exports.AvatarEditTooltip;
